import React, { useState, useEffect } from 'react';
import './Contact.css';
import Test from './Test';
import Operational from './Operational';

function CircuitBreakerTestForm({ goBack, savedGeneralData }) {  
  
  const loadFromLocalStorage = () => {
    try {

      if (savedGeneralData?.contactTestData) {
        return {
          numberOfCoils: savedGeneralData.contactTestData.numberOfCoils || 1,
          timingValues: savedGeneralData.contactTestData.timingValues || {},
          contactResistance: savedGeneralData.contactTestData.contactResistance || { R: '', Y: '', B: '' },
          coilResistance: savedGeneralData.contactTestData.coilResistance || {
            closing: { value: '', unit: 'Ω' },
            tripping: {},
            spring: { value: '', unit: 'Ω' }
          }
        };
      }
      
    
      const savedData = localStorage.getItem('timeIntervalData');
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        return {
          numberOfCoils: parsedData.numberOfCoils || 1,
          timingValues: parsedData.timingValues || {},
          contactResistance: parsedData.contactResistance || { R: '', Y: '', B: '' },
          coilResistance: parsedData.coilResistance || {
            closing: { value: '', unit: 'Ω' },
            tripping: {},
            spring: { value: '', unit: 'Ω' }
          }
        };
      }
    } catch (error) {
      
    }
    
    return {
      numberOfCoils: 1,
      timingValues: {},
      contactResistance: { R: '', Y: '', B: '' },
      coilResistance: {
        closing: { value: '', unit: 'Ω' },
        tripping: {},
        spring: { value: '', unit: 'Ω' }
      }
    };
  };

  
  const loadedData = loadFromLocalStorage();
  const [numberOfCoils, setNumberOfCoils] = useState(loadedData.numberOfCoils);
  const [showCircuitBreakerForm, setShowCircuitBreakerForm] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [timingValues, setTimingValues] = useState(loadedData.timingValues);
  const [contactResistance, setContactResistance] = useState(loadedData.contactResistance);
  const [coilResistance, setCoilResistance] = useState(loadedData.coilResistance);

  
  useEffect(() => {
  const shouldSave = numberOfCoils > 0 || 
                     Object.keys(timingValues).length > 0 || 
                     Object.values(contactResistance).some(v => v !== '') ||
                     Object.values(coilResistance).some(section => 
                       typeof section === 'object' && section.value !== ''
                     );
  
  if (shouldSave) {
    const formData = {
      numberOfCoils,
      timingValues,
      contactResistance,
      coilResistance
    };
    
    try {
      localStorage.setItem('timeIntervalData', JSON.stringify(formData));
    } catch (error) {
      
    }
  }
}, [numberOfCoils, timingValues, contactResistance, coilResistance]);


useEffect(() => {

  return () => {
    const formData = {
      numberOfCoils,
      timingValues,
      contactResistance,
      coilResistance
    };
    localStorage.setItem('timeIntervalData', JSON.stringify(formData));
  };
}, [numberOfCoils, timingValues, contactResistance, coilResistance]);


  useEffect(() => {
    const formData = {
      numberOfCoils,
      timingValues,
      contactResistance,
      coilResistance
    };
    
    try {
      localStorage.setItem('timeIntervalData', JSON.stringify(formData));
    } catch (error) {
     
    }
  }, [numberOfCoils, timingValues, contactResistance, coilResistance]);

  const handleCoilCountChange = (event) => {
    setNumberOfCoils(parseInt(event.target.value, 10));
  };

 const handleBackClick = () => {
  
  const formData = {
    numberOfCoils,
    timingValues,
    contactResistance,
    coilResistance
  };
  
  try {
    localStorage.setItem('timeIntervalData', JSON.stringify(formData));
  } catch (error) {
  
  }
  
  if (goBack) {
    goBack();
  } else {
    setShowCircuitBreakerForm(true);
  }
};

  const handleTimingInputChange = (rowKey, phase, value) => {
    
    const cleaned = value.replace(/[^0-9.]/g, '');
    const key = `${rowKey}-${phase}`;

    if (cleaned.trim() === '') {
      setTimingValues(prev => ({ ...prev, [key]: '' }));
    } else {
      const floatVal = `${cleaned}`;
      setTimingValues(prev => ({ ...prev, [key]: floatVal }));
    }
  };

  const handleContactInputChange = (phase, value) => {
   
    const cleaned = value.replace(/[^0-9.]/g, ''); 
    setContactResistance(prev => ({ ...prev, [phase]: cleaned }));
  };

  const handleCoilInputChange = (key, value, index = null) => {
    
    const cleaned = value.replace(/[^0-9.]/g, '');
    
    if (key === 'tripping') {
      setCoilResistance(prev => ({
        ...prev,
        tripping: { 
          ...prev.tripping, 
          [index]: { 
            ...prev.tripping[index],
            value: cleaned,
            unit: prev.tripping[index]?.unit || 'Ω'
          } 
        }
      }));
    } else {
      setCoilResistance(prev => ({ 
        ...prev, 
        [key]: {
          ...prev[key],
          value: cleaned
        }
      }));
    }
  };

  const handleUnitChange = (key, unit, index = null) => {
    if (key === 'tripping') {
      setCoilResistance(prev => ({
        ...prev,
        tripping: { 
          ...prev.tripping, 
          [index]: { 
            ...prev.tripping[index],
            unit: unit
          } 
        }
      }));
    } else {
      setCoilResistance(prev => ({ 
        ...prev, 
        [key]: {
          ...prev[key],
          unit: unit
        }
      }));
    }
  };

 
  const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};
  if (showCircuitBreakerForm) {
    return <Test />;
  }

  if (showContactForm) {
    const testFormData = {
      contactResistance,
      coilResistance,
      timingValues,
      numberOfCoils
    };
    
    return <Operational 
      goBack={() => setShowContactForm(false)} 
      contactTestData={testFormData} 
    />;
  }

  return (
   <div className="act-01">
    <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
      <div className="act-02">
        <div className="act-03">
          <h2 className="act-04">CONTACT RESISTANCE TEST</h2>
          <div className="act-05">
            {['R', 'Y', 'B'].map(phase => (
              <div key={phase} className="act-06">
                <div className="act-07">{phase} - Phase</div>
                <input
                  type="text"
                  className="act-08"
                  placeholder="Enter Measured Resistance"
                  value={contactResistance[phase]}
                  onChange={(e) => handleContactInputChange(phase, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="act-03">
          <h2 className="act-04">COIL RESISTANCE CHECK</h2>
          <div className="act-09">
            <div className="act-10">
              <div className="act-11">Closing Coil</div>
              <div className="act-12">
                <input
                  type="text"
                  className="act-13"
                  placeholder="Enter Measured Values"
                  value={coilResistance.closing.value || ''}
                  onChange={(e) => handleCoilInputChange('closing', e.target.value)}
                />
                <select
                  value={coilResistance.closing.unit}
                  onChange={(e) => handleUnitChange('closing', e.target.value)}
                  className="act-14"
                >
                  <option value="Ω">Ω</option>
                  <option value="MΩ">MΩ</option>
                  <option value="GΩ">GΩ</option>
                  <option value="TΩ">TΩ</option>
                  <option value="KΩ">KΩ</option>
                </select>
              </div>
            </div>

            {Array.from({ length: numberOfCoils }, (_, index) => (
              <div key={index} className="act-10">
                <div className="act-11">Tripping Coil-{index + 1}</div>
                <div className="act-12">
                  <input
                    type="text"
                    className="act-13"
                    placeholder="Enter Measured Values"
                    value={coilResistance.tripping[index]?.value || ''}
                    onChange={(e) => handleCoilInputChange('tripping', e.target.value, index)}
                  />
                  <select
                    value={coilResistance.tripping[index]?.unit || 'Ω'}
                    onChange={(e) => handleUnitChange('tripping', e.target.value, index)}
                    className="act-14"
                  >
                    <option value="Ω">Ω</option>
                    <option value="MΩ">MΩ</option>
                    <option value="GΩ">GΩ</option>
                    <option value="TΩ">TΩ</option>
                    <option value="KΩ">KΩ</option>
                  </select>
                </div>
              </div>
            ))}

            <div className="act-10">
              <div className="act-11">Spring Charge Motor</div>
              <div className="act-12">
                <input
                  type="text"
                  className="act-13"
                  placeholder="Enter Measured Values"
                  value={coilResistance.spring.value}
                  onChange={(e) => handleCoilInputChange('spring', e.target.value)}
                />
                <select
                  value={coilResistance.spring.unit}
                  onChange={(e) => handleUnitChange('spring', e.target.value)}
                  className="act-14"
                >
                  <option value="Ω">Ω</option>
                  <option value="MΩ">MΩ</option>
                  <option value="GΩ">GΩ</option>
                  <option value="TΩ">TΩ</option>
                  <option value="KΩ">KΩ</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="act-03 act-15">
        <div className="act-16">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h2 className="act-04" style={{ marginBottom: 0 }}>TIMING INTERVAL TEST</h2>
            <div className="act-17">
              <span>No Of Coils</span>
              <div className="act-18">
                <select
                  value={numberOfCoils || ''}
                  onChange={handleCoilCountChange}
                  className="act-19"
                >
                  {[1, 2, 3, 4].map(num => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </select>
                <div className="act-20"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="act-21">
          <div className="act-22">Reference</div>
          <div className="act-22">R - Phase (mSec)</div>
          <div className="act-22">Y - Phase (mSec)</div>
          <div className="act-22">B - Phase (mSec)</div>

          <div className="act-23">Close</div>
          {['R', 'Y', 'B'].map(phase => (
            <input
              key={`Close-${phase}`}
              className="act-24"
              placeholder={`Enter ${phase}-Phase`}
              value={timingValues[`Close-${phase}`] || ''}
              onChange={(e) => handleTimingInputChange('Close', phase, e.target.value)}
            />
          ))}

          {Array.from({ length: numberOfCoils }, (_, index) => (
            <React.Fragment key={`open-${index}`}>
              <div className="act-23">Open TC-{index + 1}</div>
              {['R', 'Y', 'B'].map(phase => (
                <input
                  key={`Open-${index}-${phase}`}
                  className="act-24"
                  placeholder={`Enter ${phase}-Phase`}
                  value={timingValues[`Open-${index}-${phase}`] || ''}
                  onChange={(e) => handleTimingInputChange(`Open-${index}`, phase, e.target.value)}
                />
              ))}
            </React.Fragment>
          ))}

          {Array.from({ length: numberOfCoils }, (_, index) => (
            <React.Fragment key={`close-open-${index}`}>
              <div className="act-23">Close-Open TC-{index + 1}</div>
              {['R', 'Y', 'B'].map(phase => (
                <input
                  key={`Close-Open-${index}-${phase}`}
                  className="act-24"
                  placeholder={`Enter ${phase}-Phase`}
                  value={timingValues[`Close-Open-${index}-${phase}`] || ''}
                  onChange={(e) => handleTimingInputChange(`Close-Open-${index}`, phase, e.target.value)}
                />
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="act-25">
        <button className="act-26" onClick={handleBackClick}>Back</button>
        <button
          className="act-26"
          onClick={() => setShowContactForm(true)}
        >
          Next
        </button>
        
      </div>
    </div>
  );
}

export default CircuitBreakerTestForm;